"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _ifOnly = _interopRequireDefault(require("if-only"));

var _enhanceFormControl = _interopRequireDefault(require("./enhance-form-control"));

var _ErrorLabel = _interopRequireDefault(require("./ErrorLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var className = function className(props) {
  return (0, _classnames.default)('TextArea', {
    'TextArea--with-errors': props.error
  });
};

var TextArea = function TextArea(props) {
  var style = props.style,
      error = props.error,
      hideErrorMessage = props.hideErrorMessage,
      onChange = props.onChange;

  var handleOnChange = function handleOnChange(e) {
    onChange ? onChange(e.target.value, e.target.name) : null;
  };

  return _react.default.createElement("div", null, _react.default.createElement(_reactTextareaAutosize.default, _extends({}, (0, _omit.default)(props, ['error', 'hideErrorMessage']), {
    minRows: 3,
    maxRows: 6,
    className: className(props),
    onChange: handleOnChange,
    style: style
  })), error & !hideErrorMessage ? _react.default.createElement(_ErrorLabel.default, {
    text: error
  }) : void 0);
};

var _default = (0, _enhanceFormControl.default)(TextArea);

exports.default = _default;